<script>
  import Image from '../image/image.svelte'
  import TopImage from '../image/top-image.svelte'
  import Tag from './tag.svelte'
  import { nrkChevronRight } from '@nrk/core-icons'

  export let lenke
  export let topplenke = false

  let linkElement

  $: ({ navn, kategorier, url, bilder, visning, fargetema } = lenke)
</script>

<style>
  .card {
    position: relative;
  }
  .toplink {
    background: white;
    border-radius: 6px;
  }

  .toplink .content h2 {
    font-size: 32px;
    line-height: 34px;
  }

  .vertikalDobbel .content h2 {
    font-size: 24px;
    line-height: 26px;
  }
  .horisontal {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: rgb(255 255 255 / 30%);
    border-radius: 30px 6px 30px 6px;
  }

  .horisontal .content {
    padding-left: 16px;
    padding-right: 22px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
  }

  .horisontal .content h2 {
    font-weight: 500;
    font-size: 16px;
  }

  .arrow {
    position: absolute;
    top: 50%;
    right: 2px;
    transform: translate(0, -50%);
    height: 20px;
    width: 20px;
  }

  :global(.nrk-chevron-right) {
    height: 20px;
    width: 20px;
    color: #444444;
  }
  a {
    text-decoration: none;
  }

  a::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .card:hover .content h2 {
    text-decoration: underline;
  }

  .content {
    padding: 0 0.8rem 1rem;
    display: flex;
    flex-direction: column-reverse;
  }

  .content h2 {
    font-size: 18px;
    margin: 0;
    margin-top: 2px;
    line-height: 20px;
  }

  @media (max-width: 600px) {
    .toplink .content h2 {
      font-size: 24px;
      line-height: 26px;
    }
    .content h2 {
      font-size: 16px;
    }
  }
</style>

<div
  class="card"
  class:toplink={topplenke && visning !== 'horisontal'}
  class:vertikalDobbel={!topplenke && visning === 'vertikal-dobbel'}>
  <div class:horisontal={visning === 'horisontal'}>
    {#if topplenke}
      <TopImage {bilder} />
    {:else}
      <Image {bilder} aspect={visning} />
    {/if}
    <div class="content">
      <a
        bind:this={linkElement}
        class="link"
        href={url}
        data-ec-id={lenke.remoteId}
        data-ec-name={navn}
        data-ec-variant="N/A"
        data-ec-category={kategorier[0]?.kortnavn || ''}>
        <h2>{navn}</h2>
      </a>
      <div class="tag">
        <Tag {lenke} />
      </div>
    </div>
  </div>
  {#if visning === 'horisontal'}
    <div class="arrow" aria-hidden="true">
      {@html nrkChevronRight}
    </div>
  {/if}
</div>
